export default {
  computed: {
    isWatchdogActiveOnDomain() {
      return (
        this.isWatchdogActive && window.location.host?.includes('watchdog')
      );
    },
    isWatchdogActive() {
      return this.$store.state.users.watchdog.isActive;
    },
    watchdogCanViewFullCarrier() {
      return this.$store.state.users.watchdog.canViewShowPage;
    },
    watchdogCanCarrierSearch() {
      return this.$store.state.users.watchdog.canCarrierSearch;
    },
    isWatchdogUIEnabled() {
      return this.$store.state.users.watchdog.ui;
    },
  },
  methods: {
    checkDomainConfig() {
      if (
        window.location.host?.includes('watchdog') &&
        !this.isWatchdogActive
      ) {
        if (!this.isActiveOnDomain)
          this.$store.commit('users/setWatchdogActive', true);
        if (!this.isWatchdogUIEnabled)
          this.$store.commit('users/setWatchdogInterface', true);
      }
    },
  },
  mounted() {
    this.checkDomainConfig();
  },
};
